import { formatShortDate, dayDiff, normalizeDateString } from '@hero/hero-utils/date';
const getActiveDateFormatted = (activatedAt) => {
    if (!activatedAt)
        return '-';
    const activatedAtNormalized = normalizeDateString(activatedAt);
    const daysAgo = dayDiff(new Date(), activatedAtNormalized);
    return `${formatShortDate(activatedAtNormalized)} (${daysAgo} ${daysAgo === 1 ? 'Day' : 'Days'})`;
};
export default getActiveDateFormatted;
